module.exports = __webpack_public_path__ + "img/dhht-1.33e281c6.png";